import { render, staticRenderFns } from "./IDCardAndFaceIdentifyModal.vue?vue&type=template&id=13df38b0&scoped=true"
import script from "./IDCardAndFaceIdentifyModal.vue?vue&type=script&lang=js"
export * from "./IDCardAndFaceIdentifyModal.vue?vue&type=script&lang=js"
import style0 from "./IDCardAndFaceIdentifyModal.vue?vue&type=style&index=0&id=13df38b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df38b0",
  null
  
)

export default component.exports